export default class TaskTypes {
  static TINKOFF = 1;
  static ZENMONEY = 2;
  static GOAL = 3;
  static STRATEGY = 4;
  static GOAL_RECALC = 5;
  static PLAN_RECALC = 10;
  static ATON_FILE_PARSE = 8;
  static ATON_CRM_PARSE = 11;
  static BCS_FILE_PARSE = 12;
  static STRATEGY_CACHE = 25;
  static FREEDOM_REPORT = 45;
  static BCS_API = 46;
  static RETURN_ACTIVES_BACKUP = 47;
  static ACTIVES_UPDATED = 48;
  static REFRESH_API = 17;
}
